import { mutatorAction } from "satcheljs";
import { ShiftRequestPanelSelectedItemType, shiftRequestsPanelStore } from "../";

export default mutatorAction('RESET_REQUESTS_PANEL_STORE', function resetRequestsPanelStore() {
    shiftRequestsPanelStore().errorMessage = null;
    shiftRequestsPanelStore().selectedRequestId = null;
    shiftRequestsPanelStore().selectedItemType = ShiftRequestPanelSelectedItemType.NotSelected;
    shiftRequestsPanelStore().isSaving = false;
});
